import {ERROR_API_CALL, MANAGE_REGISTER_LOADING, MANAGE_STORE_DEL_OPT_LOADED, MANAGE_STORE_DEL_OPT_LOADING, SUCCESS_API_CALL, LANGUAGE_HAS_CHANGED} from "../constants/action-types";

export const initialState = {
    loading: false,
    error: '',
    deliveryOptions: []
};

const registerReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SUCCESS_API_CALL:
            return {
                ...state,
                error:''
            };
        case ERROR_API_CALL:
            return {
                ...state,
                error: "Failed call API"
            }
        case MANAGE_REGISTER_LOADING:
            return {
                ...state,
                loading: action.data
            }
        case MANAGE_STORE_DEL_OPT_LOADING:
            return {
                ...state,
                loading: true
            }
        case MANAGE_STORE_DEL_OPT_LOADED:
            return {
                ...state,
                deliveryOptions: action.data,
                loading: false
            }
        default:
            return state;
    }
};
export default registerReducer;
